export default {
  invoiceQuery: {
    title: "申请开票",
    componentPath: "list/Query"
  },
  invoiceRules: {
    title: "开票需知",
    componentPath: "Rules"
  },
  invoiceList: {
    title: "申请开票",
    componentPath: "list/List"
  },
  invoiceMake: {
    title: "申请开票",
    componentPath: "Make",
    back: "invoiceList"
  },

  invoiceResult: {
    title: "申请开票结果",
    componentPath: "Result",
    back: "invoiceRules"
  }
};
